import { useFiscalCatalogsStore } from '@/store/fiscalCatalogs';

export const fiscalOptions = {
    searchPaymentForms: async (query: string | Record<string, any> = '') => {
        const store = useFiscalCatalogsStore();
        await store.searchPaymentForms(query);
        return store.payment_methods;
    },
    searchPaymentMethods: async (query: string | Record<string, any> = '') => {
        const store = useFiscalCatalogsStore();
        await store.searchPaymentMethods(query);
        return store.payment_methods;
    },
    searchFiscalRegiments: async (query: string | Record<string, any> = '') => {
        const store = useFiscalCatalogsStore();
        await store.searchFiscalRegiments(query);
        return store.fiscal_regiments;
    },
}